import { render, staticRenderFns } from "./ModalReceivedDate.vue?vue&type=template&id=a841f476&lang=pug&"
import script from "./ModalReceivedDate.vue?vue&type=script&lang=js&"
export * from "./ModalReceivedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports